import { render, staticRenderFns } from "./AamsComplaintRegApproval.vue?vue&type=template&id=5656a5d6&scoped=true&"
import script from "./AamsComplaintRegApproval.vue?vue&type=script&lang=js&"
export * from "./AamsComplaintRegApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656a5d6",
  null
  
)

export default component.exports